<template>
    <div class="flex flex-grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2">
            <card-form
                :meta="contractFormMeta"
                components-path="views/contracts/contract-card/components"
                :default-handlers="{ refresh: null, commit: null }"
                :callbacks="{ refreshData: refreshData, saveData: saveData, isDirty: null }"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
            />
        </div>
        <widgets-side-menu local-storage-key="contractElectroWidgetList" />
        <widgets-popup />
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import cardForm from '@/components/card-component/card-form.vue';
import contractFormMeta from '@/views/contracts/contract-card/card-meta';
//import { reactive } from 'vue';
import WidgetsSideMenu from '@/components/card-component/widgets-side-menu.vue';
import WidgetsPopup from '@/components/card-component/widgets-popup.vue';
import useContractWidgetList from '@/views/contracts/contract-card/widget-list';
import { getContractCard, saveContractCard } from '@/service/contract-service';
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';

const route = useRoute();

const refreshData = async () => {
    return await getContractCard(route.params.id);
};

const saveData = async data => {
    return await saveContractCard(data);
};
onMounted(async () => {});

const store = useStore();
const widgetList = useContractWidgetList();
store.dispatch('createWidgetMetaList', widgetList);

// watch(data, (value) => alert(JSON.stringify(value)));
</script>
